import { render, staticRenderFns } from "./ElencoDetail.vue?vue&type=template&id=6272399c&scoped=true&"
import script from "./ElencoDetail.vue?vue&type=script&lang=ts&"
export * from "./ElencoDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ElencoDetail.vue?vue&type=style&index=0&id=6272399c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6272399c",
  null
  
)

export default component.exports